import { useAnalytics } from "@hooks/useAnalytics";
import { type ComponentProps } from "@ts/components";
import { type CustomImage } from "@ts/sanity";
import { type Article } from "@ts/sanity";
import React, { type FC } from "react";

export type FeaturedArticleCardInputProps = ComponentProps & {
  article: Article;
};

export type FeaturedArticleCardOutputProps = Omit<
  FeaturedArticleCardInputProps,
  "article" | "handleClick"
> & {
  image?: CustomImage;
  title?: string;
  summary?: string;
  link: string;
};

export const withFeaturedArticleCard =
  (Component: FC<FeaturedArticleCardOutputProps>) =>
  ({
    name = "FeaturedArticleCard",
    article,
  }: FeaturedArticleCardInputProps) => {
    const { title, summary } = article || {};

    const link = article?.slug?.current
      ? `/articles/${article?.slug?.current}`
      : "/";

    Component.displayName = name;

    return (
      <Component
        image={article?.image}
        title={title}
        summary={summary}
        link={link}
      />
    );
  };
